import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import identity from "lodash/identity";
const defaultHosts = {
  qa: 'https://qa-media-api.xogrp.com/images',
  production: 'https://media-api.xogrp.com/images'
};
export const getDefaultEnv = () => (() => {
  if (process.env.UNION_MEDIA_API_ENV) {
    if (process.env.UNION_MEDIA_API_ENV !== "qa" && process.env.UNION_MEDIA_API_ENV !== "production") {
      throw new Error(`Expected UNION_MEDIA_API_ENV to be 'qa' or 'production'.`);
    }

    console.warn('Using UNION_MEDIA_API_ENV could result in a misconfigured environment. It is best that you use UNION_DEPLOYMENT_ENV for all your Union services integrations.');
    return process.env.UNION_MEDIA_API_ENV;
  }

  if (process.env.UNION_DEPLOYMENT_ENV) {
    if (process.env.UNION_DEPLOYMENT_ENV !== "qa" && process.env.UNION_DEPLOYMENT_ENV !== "production") {
      throw new Error(`Expected UNION_DEPLOYMENT_ENV to be 'qa' or 'production'.`);
    }

    return process.env.UNION_DEPLOYMENT_ENV;
  }

  if (true) {
    console.warn("Expected UNION_DEPLOYMENT_ENV to be 'qa' or 'production'. NODE_ENV fallback will be removed in a future version.");
    return process.env.NODE_ENV === 'production' ? 'production' : 'qa';
  }

  throw new Error("Expected UNION_DEPLOYMENT_ENV to be either 'qa' or 'production'.");
})();

const createUrl = _ref => {
  var _context;

  let {
    env = getDefaultEnv(),
    host = process.env.UNION_MEDIA_API_HOST || defaultHosts[env],
    slug,
    id,
    src = _filterInstanceProperty(_context = [host, slug, id]).call(_context, identity).join('/')
  } = _ref;
  return src;
};

export default createUrl;